import { Box, Loader, ThemeIcon } from "@mantine/core";
import { IconCheck, IconPointFilled, IconX } from "@tabler/icons-react";
import { ExtractionStepStatus } from "../../types";

interface StepStatusIconProps {
  status?: ExtractionStepStatus;
}

export function StepStatusIcon({ status }: StepStatusIconProps) {
  if (status === "running") return <Loader size="xs" />;
  if (status === "completed") {
    return (
      <ThemeIcon size={16} radius="xl" color="green" variant="filled">
        <IconCheck size={10} />
      </ThemeIcon>
    );
  }
  if (status === "failed") {
    return (
      <ThemeIcon size={16} radius="xl" color="red" variant="light">
        <IconX size={10} />
      </ThemeIcon>
    );
  }
  return (
    <Box c="gray.4" style={{ display: "flex" }}>
      <IconPointFilled size={12} />
    </Box>
  );
}
